/**
 * 变更主体信息
 */
"use strict";
angular.module("changeMainOperInfoRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("changeMainOperInfo", {
        url: "/changeMainOperInfo",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
                    '<div class="view_body">' +
                    '<div class="" ui-view="main"></div>' +
                    '</div>'
            },
            "header@changeMainOperInfo": {
                templateUrl: 'header/header_tpl.html',
                controller: 'headerCtrl'
            },
            "main@changeMainOperInfo": {
                templateUrl: "./main/settings/mainOperationInfo/changeMainOperInfo/changeMainOperInfo_tpl.html",
                controller: "changeMainOperInfoCtrl"
            }
        }
    });
}]);